export const API_BASE_URL =
  process.env.PUBLIC_API_BASE_URL || "http://localhost:8010";
export const DEFAULT_APP_TITLE =
  process.env.PUBLIC_DEFAULT_APP_TITLE || "ClarifAI";
